import POIDocumentsContainer from './POIDocumentsContainer';

export {
    POIDocumentsContainer
};

export default POIDocumentsContainer;
